export const VULNERABLE_LIST = 'VULNERABLE_LIST';
export const VULNERABLE_LIST_SUCCESS = 'VULNERABLE_LIST_SUCCESS';
export const VULNERABLE_LIST_ERROR = 'VULNERABLE_LIST_ERROR';

export const VULNERABLE_DETAILS = 'VULNERABLE_DETAILS';

export const VULNERABLE_INSPECTION_LIST = 'VULNERABLE_INSPECTION_LIST';
export const VULNERABLE_INSPECTION_LIST_SUCCESS = 'VULNERABLE_INSPECTION_LIST_SUCCESS';
export const VULNERABLE_INSPECTION_LIST_ERROR = 'VULNERABLE_INSPECTION_LIST_ERROR';


export const USERS_LIST = 'USERS_LIST';
export const USERS_LIST_SUCCESS = 'USERS_LIST_SUCCESS';
export const USERS_LIST_ERROR = 'USERS_LIST_ERROR';